import { toFirstLowerCase } from 'infrastructure/functions';

import { deleteUnnecessaryEmptyLines } from '../helpers';

type TData = {
  patientDevices: string[];
  didReceiveSetUpCall: any;
  reviewRPMProgramGoal: any;
  reviewRPMProgramGoal2: any;
  reviewCareTeam: string[];
  remoteDevices: any;
  careTeamContactInformation: any;
  whichPerson: string;
  otherPerson: string;
};

const joinArray = (arr: string[]) => arr?.join(', ');

export const generateIntroCallMessage = <T extends TData>(data: T) => {
  const {
    patientDevices,
    didReceiveSetUpCall,
    reviewRPMProgramGoal,
    reviewRPMProgramGoal2,
    reviewCareTeam,
    remoteDevices,
    careTeamContactInformation,
    whichPerson,
    otherPerson,
  } = data;
  let message = '';
  const isPatient = whichPerson === 'Patient';
  const target =
    whichPerson === 'Other'
      ? toFirstLowerCase(otherPerson as string)
      : toFirstLowerCase(whichPerson as string);

  const speakWith = isPatient ? 'patient' : `${target}`;

  if (patientDevices.length > 0) {
    message += `MA confirmed ${speakWith} received the following devices: ${joinArray(
      patientDevices,
    )}. `;
  }
  if (didReceiveSetUpCall === 'yes') {
    message += '\n';
    message += `MA confirmed ${speakWith} did receive set-up call from Onboarding team. `;
    message += '\n';
    message += '\n';
  }
  if (didReceiveSetUpCall === 'no') {
    message += '\n';
    message += `MA confirmed ${speakWith} did not receive set-up call from Onboarding team. `;
    message += '\n';
    message += '\n';
  }
  if (reviewRPMProgramGoal.length > 0) {
    message += `MA educated ${speakWith} that a goal of the RPM program is to help patients better manage their health, meaning patients learn the skills to manage the symptoms of their ${joinArray(
      reviewRPMProgramGoal,
    )}. `;
    message += '\n';
  }
  if (remoteDevices.length > 0) {
    message += `The provider is encouraging patients to use a remote device to help them understand what changes in these vitals could mean for patient well-being, including: ${joinArray(
      remoteDevices,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (reviewRPMProgramGoal2.length > 0) {
    message += `MA advised ${speakWith} that remote devices provide the care team with another tool to assess the effectiveness of medications and interventions. `;
    message += '\n';
  }
  if (reviewCareTeam.length > 0) {
    message += '\n';
    message += '\n';
    message += `MA reviewed what happens next with ${speakWith}. `;
    reviewCareTeam.forEach((msg) => {
      message += '\n';
      if (msg.includes('(review thresholds with patient)'))
        message += `Your provider has determined what your safe or “in range” numbers are.`;
      else {
        message += `${msg}. `;
      }
    });
    message += '\n';
    message += '\n';
  }
  if (careTeamContactInformation.length > 0) {
    message += `MA reviewed care team contact information. ${joinArray(
      careTeamContactInformation,
    )}. `;
  }

  message = deleteUnnecessaryEmptyLines(message);
  return message;
};
